module.exports = __webpack_public_path__ + "img/home_icon_shigong_sel.40e8dd96.png";